import { observer } from 'mobx-react';
import { useFormContext } from 'react-hook-form';
import { forwardRef } from 'react';
import AutoComplete from './AutoComplete';

const ServiceProviderLocation = forwardRef(
  ({ field, activeOnly, ...props }, ref) => {
    const nameKey = 'locationName';
    const valueKey = 'id';

    const searchKey = 'locationName';

    const { getValues } = useFormContext();
    const serviceProviderId = getValues('serviceProviderId');
    const basePath = `service-providers/${serviceProviderId}/locations`;
    const apiPath = activeOnly ? `${basePath}/?status=$eq:ACTIVE` : basePath;

    return (
      <AutoComplete
        ref={ref}
        nameKey={nameKey}
        valueKey={valueKey}
        apiPath={apiPath}
        searchKey={searchKey}
        field={field}
        {...props}
      />
    );
  },
);

export default observer(ServiceProviderLocation);
